import { render, staticRenderFns } from "./EmployeesSliceFloatBtns.vue?vue&type=template&id=0cd2976b&"
import script from "./EmployeesSliceFloatBtns.vue?vue&type=script&lang=js&"
export * from "./EmployeesSliceFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports